<script setup lang="ts">
withDefaults(defineProps<{
  type?: string
  placeholder?: string
  disabled?: boolean
}>(), {
  disabled: false,
  placeholder: '',
  type: 'text',
})

const model = defineModel<string>({ required: true })
</script>

<template>
  <input
    v-model="model"
    :type="type"
    :placeholder="placeholder || undefined"
    :disabled="disabled"
    class="form-control"
  >
</template>

<style lang="scss" scoped>
@use '~/components/admin/admin-shell-tokens' as *;

.form-control {
  @include admin-form-control-token-rules;

  display: block;
  width: 100%;
  height: 40px;
  padding: 0 12px;
  border-radius: 8px;
}
</style>
